"use strict";
const PostCSS8Plugin_1 = require("./PostCSS8Plugin");
const PostCSS7Plugin_1 = require("./PostCSS7Plugin");
module.exports = (postcss) => {
    if ((0, PostCSS8Plugin_1.isPostCSSv8)(postcss)) {
        return (0, PostCSS8Plugin_1.asPostCSSv8PluginGenerator)();
    }
    else {
        return (0, PostCSS7Plugin_1.asPostCSSv7PluginGenerator)(postcss);
    }
};
